import React from 'react';

export default class Home extends React.Component {
  render() {
    return (
        <div>
          <p className="home-paragraph">Welcome to my Pokedex! Here you can access "Pokedex" to see Pokémons and choose your favorite ones!</p>
        </div>
    );
    }
}
